// src/apiConfig
//
// Where this site's forms post. One place, on purpose.
//
// The base URL used to be hardcoded separately in Contact, Bookings and the
// ZumoDO showcase. When the backend moved to a new App Service, all three went
// stale together and nothing said so: two of them quietly kept posting to a
// decommissioned host, and the third had no fallback at all, so a build without
// REACT_APP_API_URL sent form submissions to the string "undefined".
//
// A visitor saw a normal form. The lead went nowhere.
//
// Anything that talks to the backend imports API_BASE from here, so moving the
// backend again is a one-line change rather than a search.
//
// REACT_APP_API_URL still wins when set, which is what local development and
// any future staging environment use. The default is production, so a build
// that forgets the variable is correct rather than broken.

export const API_BASE =
    process.env.REACT_APP_API_URL
    || 'https://webappzumosoft-hjakekbyf4duf0h0.eastus2-01.azurewebsites.net';

export default API_BASE;
